import {
  arrayBuilderYesNoSchema,
  arrayBuilderYesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { formatFullName } from 'platform/shared/health-apps';
import content from '../../../../locales/en/content.json';

const yesNoOptions = { hint: null, labelHeaderLevel: '' };

/** @type {ArrayBuilderOptions} */
export const dependentOptions = {
  arrayPath: 'dependents',
  nounPlural: content['dependent-info--array-noun-plural'],
  nounSingular: content['dependent-info--array-noun-singular'],
  required: false,
  text: {
    getItemName: item => formatFullName(item.fullName, { includeMiddle: true }),
    cardDescription: item => item?.dependentRelation,
    cancelAddYes: content['array-builder--cancel-add-yes-label'],
    cancelAddNo: content['array-builder--cancel-add-no-label'],
    cancelEditYes: content['array-builder--cancel-edit-yes-label'],
    cancelEditNo: content['array-builder--cancel-edit-no-label'],
    deleteNo: content['array-builder--delete-no-label'],
    summaryTitle: content['dependent-info--summary-title'],
    summaryTitleWithoutItems: content['dependent-info--overview-title'],
  },
};

export default {
  uiSchema: {
    'view:reportDependents': arrayBuilderYesNoUI(
      dependentOptions,
      yesNoOptions,
      yesNoOptions,
    ),
  },
  schema: {
    type: 'object',
    required: ['view:reportDependents'],
    properties: {
      'view:reportDependents': arrayBuilderYesNoSchema,
    },
  },
};
